import * as url from "../url_helper";

import { post } from "../api_helper";

export const getStateList = () => post(url.GET_STATE_LIST);
export const getCityList = data => post(url.GET_CITY_LIST, data);
